<template>
  <div>appointment</div>
</template>

<script>
export default {
  name: 'Appointment',
}
</script>

<style lang="less" scoped></style>
